import { Injectable } from "@angular/core";
import { ToggleSection } from "src/app/inspection/new-inspection/models/toggle-section";

@Injectable({
  providedIn: "root",
})
export class SortingService {
  constructor() {}

  public sortTogglesAlogithm(
    toggleA: ToggleSection,
    toggleB: ToggleSection,
    sections,
  ) {
    const sectionA = sections.find((section) => section.id == toggleA.id);
    const sectionB = sections.find((section) => section.id == toggleB.id);

    return this.sortSectionsAlgorithm(sectionA, sectionB, sections);
  }

  public sortSectionsAlgorithm(sectionA: any, sectionB: any, sections: any) {
    if (!sectionA.grouping && !sectionB.grouping) {
      return this.normalOrder(sectionA, sectionB);
    } else {
      if (sectionA.grouping && !sectionB.grouping) {
        if (sectionA.grouping.containsGroup || !sectionA.grouping.parentId)
          return this.normalOrder(sectionA, sectionB);
        else
          return this.normalOrder(
            sections.find((s) => s.id === sectionA.grouping.parentId),
            sectionB,
          );
      } else if (!sectionA.grouping && sectionB.grouping) {
        if (sectionB.grouping.containsGroup || !sectionB.grouping.parentId)
          return this.normalOrder(sectionA, sectionB);
        else
          return this.normalOrder(
            sectionA,
            sections.find((s) => s.id === sectionB.grouping.parentId),
          );
      } else {
        if (sectionA.grouping.containsGroup && sectionB.grouping.containsGroup)
          return this.normalOrder(sectionA, sectionB);
        else if (
          sectionA.grouping.containsGroup &&
          !sectionB.grouping.containsGroup
        ) {
          if (sectionA.id === sectionB.grouping.parentId) return -1;
          else if (sectionB.grouping.parentId) {
            return this.normalOrder(
              sectionA,
              sections.find((s) => s.id === sectionB.grouping.parentId),
            );
          } else {
            return this.normalOrder(sectionA, sectionB);
          }
        } else if (
          !sectionA.grouping.containsGroup &&
          sectionB.grouping.containsGroup
        ) {
          if (sectionB.id === sectionA.grouping.parentId) return 1;
          else if (sectionA.grouping.parentId)
            return this.normalOrder(
              sections.find((s) => s.id === sectionA.grouping.parentId),
              sectionB,
            );
          else {
            return this.normalOrder(sectionA, sectionB);
          }
        } else {
          if (!sectionA.grouping.parentId && !sectionB.grouping.parentId) {
            return this.normalOrder(sectionA, sectionB);
          } else if (
            !sectionA.grouping.parentId &&
            sectionB.grouping.parentId
          ) {
            return this.normalOrder(
              sectionA,
              sections.find((s) => s.id === sectionB.grouping.parentId),
            );
          } else if (
            sectionA.grouping.parentId &&
            !sectionB.grouping.parentId
          ) {
            return this.normalOrder(
              sections.find((s) => s.id === sectionA.grouping.parentId),
              sectionB,
            );
          }
          if (sectionA.grouping.parentId === sectionB.grouping.parentId)
            return this.normalOrder(sectionA, sectionB);
          else {
            return this.normalOrder(
              sections.find((s) => s.id === sectionA.grouping.parentId),
              sections.find((s) => s.id === sectionB.grouping.parentId),
            );
          }
        }
      }
    }
  }

  normalOrder(sectionA: any, sectionB: any) {
    if (sectionA?.order > sectionB?.order) return 1;
    else if (sectionA?.order < sectionB?.order) return -1;
    else return 0;
  }
}
